/** Marketing site motion tokens (SSOT). */
export const SITE_PAGE_REVEAL_DURATION = '500' as const;

export type SitePageRevealDuration = typeof SITE_PAGE_REVEAL_DURATION | '700';
